import row from "./row";
import column from "./column";

export default (editor, opts = {}) => {
  const domc = editor.DomComponents;

  column(domc, { editor, ...opts });
  row(domc, { editor, ...opts });
};
